module.exports = __webpack_public_path__ + "static/media/slideshare.ca073d5e.svg";